import { render, staticRenderFns } from "./ProfileMulticast.vue?vue&type=template&id=147cf904&"
import script from "./ProfileMulticast.vue?vue&type=script&lang=js&"
export * from "./ProfileMulticast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports